import styled from 'styled-components';
import { COLOR, FONT_SIZE, RADIUS, SPACING } from '../../../constants/theme';

export const DocumentType = styled.span`
  display: inline-block;
  margin-bottom: ${SPACING.md};
  padding: ${SPACING.xs} ${SPACING.sm};
  border-radius: ${RADIUS.sm};
  background: ${COLOR.primaryLight};
  color: ${COLOR.primary};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const IssuerName = styled.div`
  font-size: ${FONT_SIZE.value};
  font-weight: 700;
  color: ${COLOR.navy};
`;

export const IssuerMeta = styled.div`
  margin-top: 2px;
  font-size: ${FONT_SIZE.hint};
  color: ${COLOR.textSecondary};
`;

export const MetaGrid = styled.dl`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${SPACING.md} ${SPACING.lg};
  margin: ${SPACING.lg} 0 0;
`;

export const MetaItem = styled.div`
  min-width: 0;
`;

export const MetaLabel = styled.dt`
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${COLOR.textSecondary};
`;

export const MetaValue = styled.dd`
  margin: 0;
  font-size: ${FONT_SIZE.value};
  font-weight: 500;
  color: ${COLOR.text};
  word-break: break-word;
`;

export const LineItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${SPACING.lg};
  padding: ${SPACING.md} 0;
  border-top: 1px solid ${COLOR.border};
  border-bottom: 1px solid ${COLOR.border};
`;

export const LineItemDescription = styled.div`
  font-size: ${FONT_SIZE.value};
  font-weight: 500;
  color: ${COLOR.text};
`;

export const LineItemDetail = styled.div`
  margin-top: 2px;
  font-size: ${FONT_SIZE.body};
  color: ${COLOR.textSecondary};
`;

export const LineItemAmount = styled.div`
  font-size: ${FONT_SIZE.value};
  font-weight: 500;
  white-space: nowrap;
  color: ${COLOR.text};
  font-variant-numeric: tabular-nums;
`;
